import ApiService from '@/data/services/ApiService'
import { ITest } from '@/data/models/Test'
import { AxiosResponse } from 'axios'
import { IServiceResponse } from '@/data/models/ServiceResponse'

export interface IMeasuredDiagnosticVariable {
  var_id: string;
  var: string;
  unit: string | null;
  test_name: string | null;
}

export class DiagnosticVariableApiService extends ApiService {
  /**
   * Returns paginated list of DiagnosticVariables
   */
  static async getAll(params: object): Promise<IServiceResponse<ITest>> {
    return this.axios.get('diagnostic-variables', {
      params
    })
      .then((response: AxiosResponse<IServiceResponse<ITest>>) => response.data)
  }

  static async getMeasured(params: {
    player_ids?: number[],
    team_id?: number,
    event_at_date_gte?: string,
    event_at_date_lte?: string
  }): Promise<{ data: { variables: IMeasuredDiagnosticVariable[] } }> {
    return this.axios.get('diagnostic-variables/measured', { params })
      .then((response: AxiosResponse<{ data: { variables: IMeasuredDiagnosticVariable[] } }>) => response.data)
  }
}
